<template>

    <button class="dropdown-toggle"
            v-bind="$attrs"
            data-bs-toggle="dropdown"> {{ buttonLabel }}
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#" @click="setDistance(0)">{{ zeroDefault }}</a></li>
      <li v-for="distance in distances"><a class="dropdown-item" href="#" @click="setDistance(distance)">{{ distance }}km</a></li>
    </ul>

</template>

<script>
// disable default attribute inheritance
export default {
  inheritAttrs: false
}
</script>

<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
  modelValue: Number,
  zeroDefault: String,
  distances: Array
});

const emit = defineEmits(['update:modelValue']);

const currentDistance = ref(props.modelValue);

watch(() => props.modelValue, (newVal, oldVal) => {
  currentDistance.value = newVal;
});

const buttonLabel = computed(() => {
  return currentDistance.value === 0 ? props.zeroDefault : currentDistance.value+'km'
});

const setDistance = value => {
  if(value !== currentDistance.value) {
    emit('update:modelValue', value);
  }
  currentDistance.value = value;
}
</script>

<style scoped>

</style>